import {useEffect, useState} from 'react'
import Loader from '../../custom/loader/Loader'
import {useTranslation} from 'react-i18next'
import SocialMedia from 'app/modules/student/SocialMedia'
import {useAuth} from 'app/modules/auth'
import InactiveUser from './InactiveUser'
import {toAbsoluteUrl} from '_metronic/helpers'
import OnlineStdMenu from 'app/modules/online-student/OnlineStdMenu'

const OnlineStdDashboard = () => {
  const [loader, setLoader] = useState(true)
  const {t} = useTranslation()
  const [isActive, setIsActive] = useState(false)
  const {currentUser} = useAuth()

  useEffect(() => {
    if (currentUser?.status === 'Inactive') setIsActive(true)
    setLoader(false)
  }, [])

  if (loader) return <Loader />

  return (
    <>
      <OnlineStdMenu />
      <div className='banner-container mb-4 shadow-sm'>
        <img
          src={toAbsoluteUrl('/media/bg/castle.jpeg')}
          alt='welcome'
          className='banner-image'
        />

        <div className='banner-content'>
          <div className='banner-icon'>
            <i className='fas fa-graduation-cap'></i>
            <span className='banner-star'>
              <i className='fas fa-star'></i>
            </span>
          </div>

          <div>
            <h1 className='banner-title'>{t('ONLINE.WELCOME') + ' ' + currentUser?.username}</h1>
            <p className='banner-subtitle'>{t('ONLINE.STD_WEL_MSG')}</p>
          </div>
        </div>
      </div>

      <SocialMedia />
      {isActive && <InactiveUser modelType={'Student'} />}
    </>
  )
}

export default OnlineStdDashboard
